// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jaToh","content":"styles_content__K2XQY","nav_item":"styles_nav_item__DMKhN","badge":"styles_badge__Y8epJ","active_item":"styles_active_item__vbQLv"};